// src/composables/useMenuContext.js
import { ref, provide, inject } from 'vue'

// 심볼 키 생성
const menuContextKey = Symbol('menu-context')

// 메뉴 컨텍스트 제공자
export function provideMenuContext() {
  const currentMenuType = ref('')

  const setMenuType = (type) => {
    currentMenuType.value = type
  }

  const context = {
    currentMenuType,
    setMenuType
  }

  provide(menuContextKey, context)

  return context
}

// 메뉴 컨텍스트 주입
export function useMenuContext() {
  const context = inject(menuContextKey)

  if (!context) {
    throw new Error('useMenuContext must be used within a menu context provider')
  }

  return context
}
